module.exports = __webpack_public_path__ + "img/Virgin Islands.f36067e6.svg";